import { Body1, Responsive } from '@cian/ui-kit';
import React from 'react';
import * as styles from './styles.css';
import { IPriceCell } from '../../../../../../types/newbuildingsCompare';
import clsx from 'clsx';
import { PriceCellDesktop } from './PriceCellDesktop';
import { PriceCellMobile } from './PriceCellMobile';

export interface IPriceCellProps {
  cell: IPriceCell;
}

export const PriceCell = ({ cell }: IPriceCellProps): React.JSX.Element => {
  if (cell.data?.text) {
    return (
      <div className={clsx(styles['cell-container'], styles['container'])}>
        <Responsive phone tablet>
          <PriceCellMobile data={cell.data} />
        </Responsive>
        <Responsive desktop>
          <PriceCellDesktop data={cell.data} />
        </Responsive>
        <Body1>{cell.data?.text}</Body1>
      </div>
    );
  }

  return (
    <div className={clsx(styles['cell-container'], styles['no-data-container'])}>
      <Body1 color="text-primary-disabled">{cell.state.text ?? ''}</Body1>
    </div>
  );
};
